<template>
  <v-card class="recharge mw-800 mx-auto" elevation="0">
    <h1 class="mb-10 mw-300">
      <span class="d-block">
        {{ $t('recharge.select') }}
      </span>
      {{ $t('recharge.rechargeType') }}
    </h1>

    <div class="recharge__wrapper">
      <div
        class="recharge__item"
        @click="setRechargeFields({ type: 'ASAAS_CREDIT_CARD' })"
      >
        <v-icon>
          mdi-credit-card-outline
        </v-icon>
        <h2 class="mt-3">
          <span class="d-block caption">
            {{ $t('recharge.with') }}
          </span>
          <span class="font-weight-bold">
            {{ $t('recharge.card.title') }}
          </span>
        </h2>
        <div class="mw-200 mx-auto">
          <v-divider class="my-3 grey lighten-3" />
          <h6 class="d-block body-2 grey--text">
            {{ $t('recharge.paymentInfo.credit') }}
          </h6>
        </div>
      </div>
      <div
        class="recharge__item"
        @click="setRechargeFields({ type: 'ASAAS_PIX' })"
      >
        <PixIcon width="50" height="57" opacity="0.1" />
        <h2 class="mt-3">
          <span class="d-block caption">
            {{ $t('recharge.with') }}
          </span>
          <span class="font-weight-bold">
            {{ $t('recharge.pix.title') }}
          </span>
        </h2>
        <div class="mw-200 mx-auto">
          <v-divider class="my-3 grey lighten-3" />
          <h6 class="d-block body-2 grey--text">
            {{ $t('recharge.paymentInfo.pix') }}
          </h6>
        </div>
      </div>
      <div
        class="recharge__item"
        @click="setRechargeFields({ type: 'ASAAS_BOLETO' })"
      >
        <v-icon>
          mdi-barcode
        </v-icon>
        <h2 class="mt-3">
          <span class="d-block caption">
            {{ $t('recharge.with') }}
          </span>
          <span class="font-weight-bold">
            {{ $t('recharge.billet.title') }}
          </span>
        </h2>
        <div class="mw-200 mx-auto">
          <v-divider class="my-3 grey lighten-3" />
          <h6 class="d-block body-2 grey--text">
            {{ $t('recharge.paymentInfo.billet') }}
          </h6>
        </div>
      </div>
    </div>

    <v-btn
      @click="openModal('BILLET_INFO_MODAL')"
      class="recharge__billet-info"
      icon
    >
      <v-icon>
        mdi-information-outline
      </v-icon>
    </v-btn>

    <ModalBilletInfo />
  </v-card>
</template>

<script>
import ModalBilletInfo from './modals/ModalBilletInfo'
import PixIcon from '@/components/icons/Pix'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'RechargeSelectType',

  components: {
    PixIcon,
    ModalBilletInfo,
  },

  methods: {
    ...mapActions(['openModal']),
    ...mapMutations(['setRechargeFields']),
  },
}
</script>
